import {RadioGroup, RadioGroupItem} from '../RadioGroup';
import {Typography} from '../Typography';

import type {CreatedAtFilter} from './list.types';
import type {FC} from 'react';

export interface CreatedAtOption {
  value: CreatedAtFilter;
  label: string;
}

export interface ListFilterCreatedAtSectionProps {
  sectionLabel: string;
  options: ReadonlyArray<CreatedAtOption>;
  createdAt: CreatedAtFilter;
  hasDateRange: boolean;
  onChange: (value: CreatedAtFilter) => void;
}

export const ListFilterCreatedAtSection: FC<ListFilterCreatedAtSectionProps> = ({
  sectionLabel,
  options,
  createdAt,
  hasDateRange,
  onChange
}) => {
  return (
    <div data-slot="list-filter-created-at-section">
      <div className="px-3 pb-1 pt-2">
        <Typography size="xs" weight="semibold" color="tertiary">
          {sectionLabel}
        </Typography>
      </div>
      <RadioGroup
        value={hasDateRange ? '' : createdAt}
        onValueChange={value => onChange(value as CreatedAtFilter)}
      >
        {options.map(opt => (
          <label
            key={opt.value}
            className="flex w-full cursor-pointer items-center gap-2 rounded-sm px-2 py-1.5 text-sm text-fg hover:bg-background-surface_hover"
          >
            <RadioGroupItem value={opt.value} />
            <span className="min-w-0 flex-1 truncate text-start">{opt.label}</span>
          </label>
        ))}
      </RadioGroup>
    </div>
  );
};
